import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_RESIZE_HANDLE_INPUT_SOURCE = {
  Keyboard: "keyboard",
  Pointer: "pointer",
} as const;

export const DS_RESIZE_HANDLE_NATIVE_EVENT = {
  ResizeStart: "ds-resize-handle:resize-start",
  ResizeEnd: "ds-resize-handle:resize-end",
} as const;

export type DSResizeHandleInputSource = ObjectValues<typeof DS_RESIZE_HANDLE_INPUT_SOURCE>;

export interface DSResizeHandleResizeStartDetails {
  source: typeof DS_RESIZE_HANDLE_INPUT_SOURCE.Pointer;
  coordinate: number;
  value: number;
}

export interface DSResizeHandleResizeEndDetails {
  source: typeof DS_RESIZE_HANDLE_INPUT_SOURCE.Pointer;
  delta: number;
  canceled: boolean;
}

export interface DSResizeHandleEmits {
  (event: "resize-start", details: DSResizeHandleResizeStartDetails): void;
  (event: "resize-end", details: DSResizeHandleResizeEndDetails): void;
}
